/**
 * Extracts site-independent route-based parameters
 * and injects them into the DashboardHostRouteShell.
 *
 */

import SiteDashboardPage from './SiteDashboardPage';
import { DashboardHostRouteShell } from './DashboardHostRouteShell';
import { useParams, useSearchParams } from 'react-router-dom';

// -- helper functions --

function parseRouteId(value: string | undefined): number | null {
  if (value === undefined) {
    return null;
  }

  const parsed = Number.parseInt(value, 10);
  return Number.isNaN(parsed) ? null : parsed;
}

// -- main component --

export default function StandaloneDashboardRoute() {
  const params = useParams();
  const [searchParams] = useSearchParams();
  const grid_id = parseRouteId(params.grid_id);
  const dashboard_only_mode = searchParams.get('dashboard_only_mode');
  const dashboardOnlyMode =
    dashboard_only_mode !== undefined &&
    dashboard_only_mode !== null &&
    dashboard_only_mode.toLowerCase() !== 'false';

  return (
    <DashboardHostRouteShell
      project_id={null}
      site_id={null}
      grid_id={grid_id}
      mode="standalone"
      grid_type="grids"
      simplified_view={true}
      dashboard_only_mode={dashboardOnlyMode}
    >
      <SiteDashboardPage />
    </DashboardHostRouteShell>
  );
}
